import axiosInstance from "../config/axiosInterceptor";


export async function getNodeSlotDefinition() {
  return await axiosInstance.get("/api/NodeSlotDefinition");
}

export async function getNodeSlotDefinitionById(id) {
  return await axiosInstance.get(`/api/NodeSlotDefinition/${id}`);
}

export async function postNodeSlotDefinition(data) {
  return await axiosInstance.post("/api/NodeSlotDefinition", data);
}

export async function putNodeSlotDefinition(data) {
  return await axiosInstance.put("/api/NodeSlotDefinition", data);
}

export async function deleteNodeSlotDefinition(id) {
  return await axiosInstance.delete(`/api/NodeSlotDefinition/${id}`);
}

export async function checkSlotDefinitionUsageInNodes(slotDefinitionId) {
  const nodeSlotDefinitions = await getNodeSlotDefinition();

  const usedInNodes = nodeSlotDefinitions.filter(
    (nsd) => nsd.slotDefinitionTable_idslotDefinitionTable === slotDefinitionId
  );

  return {
    isUsed: usedInNodes.length > 0,
    nodes: usedInNodes,
    count: usedInNodes.length,
  };
}
